const tools = [
    {
        title: "Smellyzer",
        explanation: "Designed to detect process smells in the code review and bug tracking processes. It identifies inefficiencies and potential issues in these critical aspects of software development, helping teams improve their workflows and enhance overall productivity. By analyzing patterns and trends in code review and bug tracking activities, Smellyzer provides actionable insights for better decision-making and process optimization. ",
       // pi: "Eray Tüzün",
        img: '/images/Smellyzer.jpeg',
    },
    {
        title: "CID (Change Impact Detector)",
        explanation: "Software analytics tool designed to enhance the code review process by providing insights into the potential impact of code changes. It combines dependency analysis and history mining techniques to analyze pull requests, offering a granular view of affected functions and risk scores based on metrics such as code churn, bug frequency, and co-change rate, thereby assisting reviewers in making informed decisions. ",
       // pi: "Eray Tüzün",
        img: '/images/CID.jpg',
    },
    {
        title: "SAA",
        explanation: "A tool to visually analyze varying software artifacts including source code files, pull requests, issues, and commits, as well as their links and their relationships with developers in a software project to improve the software development process. Check out <a href=\"https://ivis-at-bilkent.github.io/software-artifact-analyzer/\" target=\"_blank\">SAA Webpage</a> for more information.",
        //   pi: "Uğur Doğrusöz and Eray Tüzün",
        img: '/images/SAA.gif',
    },
    {
        title: "PieR",
        explanation: " PieR (Pull Request Classifier): Analyzes pull requests within a specific repository to classify them according to the origin of the issue, which could be the requirements phase, design phase, or implementation phase. Additionally, the tool categorizes pull requests based on the types of changes they introduce. Check out <a href=\"https://pier.tools/\" target=\"_blank\">PieR Webpage</a> for more information.",
    //    pi: "Eray Tüzün",
        img: '/images/PieR.jpg',
    },
    {
        title: "ReLink",
        explanation: "It is a tool designed to enhance traceability in software development by automatically linking pull requests (PRs) and issues. It offers a user-friendly web application with visualization features and a semi-automated approach, where missing links are identified based on a confidence score derived from text similarity and heuristic rules. ",
      //  pi: "Eray Tüzün",
        img: '/images/ReLink.jpg',
    },
];

export default tools;